import { render } from "./ModalFlowbite.vue?vue&type=template&id=6117c63f"
import script from "./ModalFlowbite.vue?vue&type=script&lang=js"
export * from "./ModalFlowbite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__